export function isDefined(object) {
    return typeof(object) !== 'undefined' 
}

export function isUndefined(object) {
    return !isDefined(object)
}